import { render, staticRenderFns } from "./TaskChat.vue?vue&type=template&id=f1aa0882&"
import script from "./TaskChat.vue?vue&type=script&lang=js&"
export * from "./TaskChat.vue?vue&type=script&lang=js&"
import style0 from "./TaskChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports